import { Link } from "react-router-dom";

// Inline SVG components for instant loading without caching issues
const LogoDark = ({ height }) => (
  <svg viewBox="0 0 700 200" xmlns="http://www.w3.org/2000/svg" style={{ height, width: 'auto' }}>
    <defs>
      <linearGradient id="gradDark" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#3b82f6"/>
        <stop offset="100%" stopColor="#60a5fa"/>
      </linearGradient>
    </defs>
    <g transform="translate(20,50)">
      <rect width="110" height="80" rx="18" fill="url(#gradDark)"/>
      <polygon points="40,25 40,55 75,40" fill="white"/>
    </g>
    <text x="160" y="95" fontFamily="Inter, Arial, sans-serif" fontSize="52" fontWeight="600" fill="#f1f5f9">
      mkb<tspan fill="#60a5fa">video</tspan>
    </text>
    <text x="160" y="130" fontFamily="Inter, Arial, sans-serif" fontSize="18" fill="#94a3b8">
      platform voor en door het mkb
    </text>
  </svg>
);

const LogoLight = ({ height }) => (
  <svg viewBox="0 0 700 200" xmlns="http://www.w3.org/2000/svg" style={{ height, width: 'auto' }}>
    <defs>
      <linearGradient id="gradLight" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#3b82f6"/>
        <stop offset="100%" stopColor="#60a5fa"/>
      </linearGradient>
    </defs>
    <g transform="translate(20,50)">
      <rect width="110" height="80" rx="18" fill="url(#gradLight)"/>
      <polygon points="40,25 40,55 75,40" fill="white"/>
    </g>
    <text x="160" y="95" fontFamily="Inter, Arial, sans-serif" fontSize="52" fontWeight="600" fill="#1e293b">
      mkb<tspan fill="#3b82f6">video</tspan>
    </text>
    <text x="160" y="130" fontFamily="Inter, Arial, sans-serif" fontSize="18" fill="#64748b">
      platform voor en door het mkb
    </text>
  </svg>
);

export const Logo = ({ size = "md", linkTo = "/", className = "", variant = "dark" }) => {
  // Size configurations in pixels
  const sizes = {
    sm: "50px",
    md: "70px",
    lg: "90px",
    xl: "120px"
  };

  const currentHeight = sizes[size] || sizes.md;

  const LogoContent = () => (
    <div className={`flex items-center ${className}`}>
      {variant === "light" ? (
        <LogoDark height={currentHeight} />
      ) : (
        <LogoLight height={currentHeight} />
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="hover:opacity-90 transition-opacity">
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default Logo;
